// import { defaultsDeep } from 'lodash'
import { HTTP as http } from '../../http'

const PREFIX = '/product'

const getBodyColumnsAndLines =  (item, ggo) => {
    return {
        items_grid_id: item.id,
        quantity: item.item_grid_stock,
        active: false,
        grid_description: item.grid_description,
        grid_price_site: item.grid_price_site,
        product_id: item.product_id,
        grid_abbreviation: item.grid_abbreviation,
        priority: item.priority,
        disabled: (!item.sell_out_of_stock) && item.item_grid_stock <= 0,
        sell_out_of_stock: item.sell_out_of_stock,
        minimum_sale_quantity: item.minimum_sale_quantity,
        quantity_conversion_factor: item.quantity_conversion_factor,
        maximum_sale_quantity: item.maximum_sale_quantity,
        quantity_per_box: item.quantity_per_box,
        closed_box_unit_measure: item.closed_box_unit_measure,
        closed_box_unit_measure_description: item.closed_box_unit_measure_description,
        grid_group_name: ggo?.grid_group_name ?? null,
        orientation: ggo?.orientation ?? null,
        option_description: ggo?.option_description ?? null,
        is_color: ggo?.is_color ?? false,
        is_size: ggo?.is_size ?? false,
        color_id : ggo?.color_id ?? null,
        color_name: ggo?.color_name ?? null,
        cod_exa: ggo?.cod_exa ?? null,
        cod_exa2: ggo?.cod_exa2 ?? null,
        type: ggo?.color_type ?? null,
        url_image: ggo?.color_url_image ?? null,
        path_image: ggo?.color_path_image ?? null,
        color_active: false,
        size_id: ggo?.size_id ?? null,
        size: ggo?.size_description ?? null,
        priority_option: ggo?.priority_option ?? null
    }
}

/**
 *
 * @param {*} key row ou column
 * @param {*} items itens pré-selecionados
 * @param {*} items_grid o que retorna da api
 */

const setColumOrRow = (key, items, items_grid) => {
    let key_to_get = 'column';
    if(key == 'column') {
        key_to_get = 'row'
    }
    let ggo_id = `group_option_${key}_id`
    let ggo_key_to_get = `grid_group_options_${key_to_get}`
    let ggo_id_to_get = `group_option_${key_to_get}_id`
    items_grid.map(el => {
        if(!el[ggo_id] || !el[ggo_id_to_get]) {
           return;
        }
        let value_from_ggo_id = el[ggo_id].toString()
        let value_from_ggo_id_to_get = el[ggo_id_to_get].toString()
        let ggo_to_get = {...el[ggo_key_to_get]}
        let grid_saved = {...items[key_to_get][value_from_ggo_id_to_get]}
        let keys_to_ignore = ['single_purchase_allowed', 'quantity', 'items_grid_id']
        for (const i in grid_saved) {
            if(keys_to_ignore.includes(i)) {
                continue;
            }
            if (Object.hasOwnProperty.call(el, i)) {
                const element = el[i];
                grid_saved[i] = element
                continue;
            }
            if (Object.hasOwnProperty.call(ggo_to_get, i)) {
                const element = ggo_to_get[i];
                grid_saved[i] = element
            }
        }
        grid_saved.quantity = el.item_grid_stock
        grid_saved.items_grid_id = el.id
        if(!items[key][value_from_ggo_id][key_to_get]) {
            items[key][value_from_ggo_id][key_to_get] = []
            items[key][value_from_ggo_id][key_to_get].push(grid_saved)
            return
        }
        if(!items[key][value_from_ggo_id][key_to_get].find(el => el.items_grid_id == grid_saved.items_grid_id)) {
            items[key][value_from_ggo_id][key_to_get].push(grid_saved)
        }
    });
}

export default {
    get: (id) => {
        return http.post(PREFIX+'/getJson/'+id)
    },
    persistRating: (data) => {
        return http.post(PREFIX+'/rating', data)
    },
    getAdditionalItems: (id) => {
        return http.post(PREFIX+'/getAdditionalItems/'+id)
    },

    organizeItemsGridByColumn(items_grid_columns_and_rows, item) {
        let ggo = item.grid_group_options_column
        if(!ggo) {
            return;
        }
        let column = getBodyColumnsAndLines(item, ggo)
        column.single_purchase_allowed = true
        items_grid_columns_and_rows.column[ggo.id] = column
    },
    organizeItemsGridByRow(items_grid_columns_and_rows, item) {
        let ggo = item.grid_group_options_row
        if(!ggo) {
            return;
        }
        let row = getBodyColumnsAndLines(item, ggo)
        // console.log(row)
        row.single_purchase_allowed = true
        items_grid_columns_and_rows.row[ggo.id] = row
    },
    organizeItemsGridByColumnAndRow(items_grid_columns_and_rows, item) {
        let ggo_column = item.grid_group_options_column?.id ? item.grid_group_options_column : null
        let ggo_row = item.grid_group_options_row?.id ? item.grid_group_options_row : null
        let c_id = ggo_column?.id
        let r_id = ggo_row?.id
        if(!items_grid_columns_and_rows.column[c_id] && c_id) {
            items_grid_columns_and_rows.column[c_id] = getBodyColumnsAndLines(item, ggo_column);
        }
        if(!items_grid_columns_and_rows.row[r_id] && r_id) {
            items_grid_columns_and_rows.row[r_id] = getBodyColumnsAndLines(item, ggo_row);
        }
    },
    organizeItemsGridWithoutGrid (column, item) {
        column.push(getBodyColumnsAndLines(item, null))
    },
    setColumnInRowAndRowInColumn(items_grid, items) {
        setColumOrRow('column', items, items_grid)
        setColumOrRow('row', items, items_grid)
    }
}
